import { Component, inject } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { IconComponent, IconName } from '../icon/icon.component';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [IconComponent],
  template: `
    <div
      class="fixed inset-x-4 top-4 z-50 flex flex-col gap-2 sm:inset-x-auto sm:right-4 sm:w-full sm:max-w-sm"
      aria-live="polite"
    >
      @for (toast of toastService.toasts(); track toast.id) {
        <div
          class="motion-safe-anim animate-fade-in-up flex items-start gap-3 px-4 py-3 rounded-lg shadow-lg border text-sm"
          [class]="toastClasses(toast.type)"
          role="alert"
        >
          @if (toastIcon(toast.type); as icon) {
            <span class="shrink-0 mt-0.5"><app-icon [name]="icon" [size]="16" /></span>
          }
          <span class="flex-1">{{ toast.message }}</span>
          @if (toast.action; as action) {
            <button
              (click)="toastService.runAction(toast)"
              class="shrink-0 px-2.5 py-1 -my-1 rounded-md bg-gradient-to-r from-brand-600 to-accent-500 text-white text-xs font-semibold hover:opacity-90 transition-opacity"
            >
              {{ action.label }}
            </button>
          }
          <button
            (click)="toastService.dismiss(toast.id)"
            class="opacity-60 hover:opacity-100 transition-opacity leading-none p-1 -m-1"
            aria-label="Dismiss"
          >
            <app-icon name="close" [size]="14" />
          </button>
        </div>
      }
    </div>
  `,
})
export class ToastContainerComponent {
  readonly toastService = inject(ToastService);

  toastClasses(type: string): string {
    switch (type) {
      case 'error':
        return 'bg-red-50 border-red-200 text-red-800';
      case 'success':
        return 'bg-green-50 border-green-200 text-green-800';
      default:
        return 'bg-white border-gray-200 text-gray-800';
    }
  }

  toastIcon(type: string): IconName | null {
    switch (type) {
      case 'error':
        return 'alert-circle';
      case 'success':
        return 'check-circle';
      default:
        return null;
    }
  }
}
